import { arcticLight } from './arctic-light';
import {
  orangeDark,
  orangeDark_deuteranopia,
  orangeDark_protanopia,
} from './orange-dark';

const baseThemes = {
  arcticLight,
  orangeDark,
};

export const themes = {
  ...baseThemes,
  orangeDark_deuteranopia,
  orangeDark_protanopia,
};

export const DEFAULT_THEME = 'orangeDark';

export type BaseThemeNames = keyof typeof baseThemes;
export type ThemeNames = keyof typeof themes;
